/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import DirectionButton from 'components/atoms/DirectionButton';
import ProductCard from 'components/molecules/ProductCard';
import classnames from 'classnames';
import 'swiper/css';
import 'swiper/css/navigation';
import { ProductResource } from 'util/api/swaggerApi/data-contracts';
import { useStock } from 'models/stock';
import styles from './index.module.css';

interface ProductListCarouselProperty {
	data: ProductResource[];
	className?: string;
	pageName?: string;
}

const ProductListCarousel: React.FC<ProductListCarouselProperty> = ({
	data,
	className,
	pageName,
}) => {
	const [{ allProductStock }] = useStock();
	return (
		<div className={styles.wrapper}>
			<div className="product-list-swiper-prev">
				<DirectionButton
					direction="left"
					appear="border"
					handleClick={() => {}}
					className={classnames(styles.direction, styles.left)}
				/>
			</div>
			<SwiperComponent
				spaceBetween={40}
				slidesPerView={4}
				navigation={{
					prevEl: '.product-list-swiper-prev',
					nextEl: '.product-list-swiper-next',
					disabledClass: styles.disabled,
				}}
				modules={[Navigation]}
				className={classnames(styles.swiper, className)}
			>
				<div className={styles.container}>
					{data.map((item, index) => (
						<SwiperSlide className={styles.swiperSlide} key={item.name}>
							<ProductCard
								{...item}
								index={index}
								pageName={pageName}
								className={styles.productCard}
							/>
						</SwiperSlide>
					))}
				</div>
			</SwiperComponent>
			<div className="product-list-swiper-next">
				<DirectionButton
					direction="right"
					appear="border"
					handleClick={() => {}}
					className={classnames(styles.direction, styles.right)}
				/>
			</div>
		</div>
	);
};

export default ProductListCarousel;
